import { createContext, useContext, useState, ReactNode } from "react";
import {
  PressKitData,
  PressKitContextType,
} from "../types/componentsConstructors";

const PressKitContext = createContext<PressKitContextType | undefined>(
  undefined
);

interface Props {
  children: ReactNode;
}

export const PressKitProvider = ({ children }: Props) => {
  const [pressKitData, setPressKitData] = useState<PressKitData>({});

  return (
    <PressKitContext.Provider value={{ pressKitData, setPressKitData }}>
      {children}
    </PressKitContext.Provider>
  );
};

export const usePressKit = (): PressKitContextType => {
  const context = useContext(PressKitContext);
  if (!context) {
    throw new Error("usePressKit deve ser usado dentro de PressKitProvider");
  }
  return context;
};
